import { getChemistryGrade, getDirectionSummary, toRoundedScore } from './chemistryResultUtils';

export function getChemistrySequenceMetrics(result, language) {
  const comfortScore = toRoundedScore(result?.scores?.mirror, 0);
  const attractionScore = toRoundedScore(result?.scores?.magnet, 0);
  const chemistryScore = toRoundedScore(result?.scores?.chemistry, 0);
  const confidenceScore = toRoundedScore(result?.scores?.confidence, 0);
  const grade = getChemistryGrade(chemistryScore, attractionScore, comfortScore, language);

  return {
    comfortScore,
    attractionScore,
    chemistryScore,
    confidenceScore,
    grade,
  };
}

export function getChemistrySequenceDirection(result, nameA, nameB) {
  return getDirectionSummary(
    result?.attraction_flow || result?.attention_flow || result?.directionality || result,
    nameA,
    nameB,
  );
}

export function getProgressValue(elapsedMs, start, end, finalValue) {
  if (elapsedMs <= start) return 0;
  if (elapsedMs >= end) return finalValue;
  const progress = (elapsedMs - start) / Math.max(end - start, 1);
  const eased = 1 - Math.pow(1 - progress, 3);
  return Math.round(finalValue * eased);
}
